import Vue from 'vue'

import './assets/styles/main.sass'
import './plugins'
import { router } from './router'
import App from './App'
import globalMixin from './globalMixin'
import store from './store'

Vue.config.productionTip = false
Vue.mixin(globalMixin)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
